// import React, { useEffect, useState, useRef } from "react";
// import {
//     Bar,
//     Line,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     ResponsiveContainer,
//     ComposedChart,
//     LabelList,
//     Legend,
//     Brush,
// } from "recharts";
// import { InverterDetail2 } from "../../../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress";
// import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";
// import DownloadJpegButton from "../../../../../../../../components/downloadJpegButton/DownloadJpegButton";
// // import DownloadJpegButton from "../../../../../../components/downloadJpegButton"; 

// const Tab4ContentChartIncomer = () => {
//     const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
//     const [chartData, setChartData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [tye] = useState("I");

//     const chartRef = useRef();

//     const getCredentials = () => ({
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         LOC_CODE: localStorage.getItem("LCODE") || "",
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//         TYE: tye,
//     });

//     const fetchLogData = async () => {
//         setLoading(true);
//         const credentials = getCredentials();
//         try {
//             const res = await InverterDetail2(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 const transformedData = res.data.map((item) => ({
//                     name: item.NAME,
//                     Peak_KW: parseFloat(item.KW_MAX) || 0,

//                     KW: parseFloat(item.KW) || 0,
//                     DAY_KWH: parseFloat(item.DAY_KWH) || 0,
//                 }));
//                 setChartData(transformedData);
//             } else {
//                 setChartData([]);
//             }
//         } catch (err) {
//             /* Handle error */
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, []);

//     return (
//         <>
//             <div className="row">
//                 <div className="col-md-12" style={{ height: 520, position: "relative" }}>
//                     {/* Export and Refresh Buttons */}
//                     <div
//                         style={{
//                             marginBottom: "4px",
//                             position: "absolute",
//                             top: "10px",
//                             right: "10px",
//                             zIndex: 2,
//                             display: "flex",
//                             gap: "10px",
//                             alignItems: "center",
//                         }}
//                     >
//                         <DownloadJpegButton targetRef={chartRef} fileName={`Peak KW vs KWp.jpeg`} />
//                         <IconButton onClick={fetchLogData} disabled={loading}>
//                             <Refresh />
//                         </IconButton>
//                         {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//                     </div>

//                     {/* Chart */}
//                     <div ref={chartRef} style={{ height: 320, background: "#fff", padding: "5px", marginTop: "2rem" }}>
//                         {loading ? (
//                             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//                                 <CircularProgress />
//                             </div>
//                         ) : (
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <ComposedChart
//                                     data={chartData}
//                                     margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
//                                 >
//                                     <CartesianGrid strokeDasharray="3 3" />

//                                     <XAxis
//                                         dataKey="name"
//                                         angle={-20}
//                                         textAnchor="end"
//                                         height={70}
//                                     />

//                                     <YAxis yAxisId="left" />

//                                     <YAxis
//                                         yAxisId="right"
//                                         orientation="right"
//                                     />

//                                     <Tooltip />
//                                     <Legend />

//                                     {/* Peak KW */}
//                                     <Bar
//                                         dataKey="Peak_KW"
//                                         fill="#808080"
//                                         name="Peak KW"
//                                         yAxisId="left"
//                                     >
//                                         <LabelList
//                                             dataKey="Peak_KW"
//                                             position="top"
//                                             fontSize={10}
//                                         />
//                                     </Bar>

//                                     {/* Current KW */}
//                                     <Bar
//                                         dataKey="KW"
//                                         fill="#0000ff"
//                                         name="KW"
//                                         yAxisId="left"
//                                     >
//                                         <LabelList
//                                             dataKey="KW"
//                                             position="top"
//                                             fontSize={10}
//                                         />
//                                     </Bar>

//                                     {/* Daily Generation */}
//                                     <Line
//                                         type="monotone"
//                                         dataKey="DAY_KWH"
//                                         stroke="#ff0000"
//                                         strokeWidth={3}
//                                         name="Daily kWh"
//                                         yAxisId="right"
//                                     >
//                                         <LabelList
//                                             dataKey="DAY_KWH"
//                                             position="top"
//                                             fontSize={10}
//                                         />
//                                     </Line>

//                                     <Brush
//                                         dataKey="name"
//                                         height={25}
//                                         stroke="#8884d8"
//                                     />
//                                 </ComposedChart>
//                             </ResponsiveContainer>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Tab4ContentChartIncomer;


// 2.

// import React, { useEffect, useState, useRef } from "react";
// import {
//     Bar,
//     Line,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     ResponsiveContainer,
//     ComposedChart,
//     Legend,
//     Brush,
// } from "recharts";
// import { InverterDetail2, MainSliderApi } from "../../../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress";
// import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";
// import DownloadJpegButton from "../../../../../../../../components/downloadJpegButton/DownloadJpegButton";

// const Tab4ContentChartIncomer = () => {
//     const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
//     const [chartData, setChartData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [tye] = useState("I");

//     const chartRef = useRef();

//     const getCredentials = () => ({
//         USER_ID: localStorage.getItem("LoginID"),
//         PLANT_code: localStorage.getItem("LCODE"),
//         pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         Stype: "I",
//     });


//     const fetchLogData = async () => {
//         setLoading(true);

//         try {
//             const credentials = getCredentials();
//             const res = await MainSliderApi(credentials);

//             if (res?.data && Array.isArray(res.data)) {
//                 const transformedData = res.data.map((item) => ({
//                     name: item.NAME,
//                     Peak_KW: parseFloat(item.KW_MAX) || 0,
//                     KW: parseFloat(item.KW) || 0,
//                     DAY_KWH: parseFloat(item.DAY_KWH) || 0,
//                 }));

//                 setChartData(transformedData);
//             } else {
//                 setChartData([]);
//             }
//         } catch (error) {
//             console.error("Error fetching chart data:", error);
//             setChartData([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, []);

//     return (
//         <div className="row">
//             <div
//                 className="col-md-12"
//                 style={{
//                     height: 220,
//                     position: "relative",
//                 }}
//             >
//                 {/* Action Buttons */}
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: "10px",
//                         right: "10px",
//                         zIndex: 10,
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "10px",
//                     }}
//                 >
//                     <DownloadJpegButton
//                         targetRef={chartRef}
//                         fileName="Peak_KW_vs_KW.jpeg"
//                     />

//                     <IconButton
//                         onClick={fetchLogData}
//                         disabled={loading}
//                     >
//                         <Refresh />
//                     </IconButton>

//                     {loading && <CircularProgress size={24} />}
//                 </div>

//                 {/* Chart */}
//                 <div
//                     ref={chartRef}
//                     style={{
//                         height: 215,
//                         background: "#fff",
//                         padding: "10px",
//                         marginTop: "50px",
//                     }}
//                 >
//                     {loading ? (
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 height: "100%",
//                             }}
//                         >
//                             <CircularProgress />
//                         </div>
//                     ) : (
                        
//                         <ResponsiveContainer width="100%" height="100%">
//                             <ComposedChart
//                                 data={chartData}
//                                 margin={{
//                                     top: 20,
//                                     right: 40,
//                                     left: 20,
//                                     bottom: 20,
//                                 }}
//                             >
//                                 <CartesianGrid strokeDasharray="3 3" />

//                                 <XAxis
//                                     dataKey="name"
//                                     angle={-20}
//                                     textAnchor="end"
//                                     height={70}
//                                     interval={0}
//                                     tick={{ fontSize: 11 }}
//                                 />

//                                 {/* LEFT AXIS - Peak KW & Current KW */}
//                                 <YAxis
//                                     yAxisId="left"
//                                     orientation="left"
//                                     width={70}
//                                     tick={{ fontSize: 12 }}
//                                     label={{
//                                         value: "Peak KW / Current KW",
//                                         angle: -90,
//                                         position: "insideLeft",
//                                         style: {
//                                             textAnchor: "middle",
//                                         },
//                                     }}
//                                 />

//                                 {/* RIGHT AXIS - Daily kWh */}
//                                 <YAxis
//                                     yAxisId="right"
//                                     orientation="right"
//                                     width={70}
//                                     tick={{ fontSize: 12 }}
//                                     label={{
//                                         value: "Daily kWh",
//                                         angle: 90,
//                                         position: "insideRight",
//                                         style: {
//                                             textAnchor: "middle",
//                                         },
//                                     }}
//                                 />

//                                 <Tooltip
//                                     cursor={{
//                                         fill: "rgba(0,0,0,0.05)",
//                                     }}
//                                     contentStyle={{
//                                         backgroundColor: "#fff",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "8px",
//                                     }}
//                                     formatter={(value, name) => [
//                                         Number(value).toLocaleString(),
//                                         name,
//                                     ]}
//                                 />

//                                 <Legend
//                                     verticalAlign="top"
//                                     align="center"
//                                     wrapperStyle={{
//                                         paddingBottom: "10px",
//                                     }}
//                                 />

//                                 {/* Peak KW */}
//                                 <Bar
//                                     yAxisId="left"
//                                     dataKey="Peak_KW"
//                                     name="Peak KW"
//                                     fill="#FFA500"
//                                     barSize={22}
//                                 />

//                                 {/* Current KW */}
//                                 <Bar
//                                     yAxisId="left"
//                                     dataKey="KW"
//                                     name="Current KW"
//                                     fill="#FFDE21"
//                                     barSize={22}
//                                 />

//                                 {/* Daily kWh */}
//                                 <Line
//                                     yAxisId="right"
//                                     type="monotone"
//                                     dataKey="DAY_KWH"
//                                     name="Daily kWh"
//                                     stroke="#008080"
//                                     strokeWidth={3}
//                                     dot={{ r: 4 }}
//                                     activeDot={{ r: 7 }}
//                                 />
//                             </ComposedChart>
//                         </ResponsiveContainer>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Tab4ContentChartIncomer; 

// 3.

import React, { useEffect, useState, useRef } from "react";
import {
    Bar,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ComposedChart,
    Legend,
} from "recharts";
import { MainSliderApi } from "../../../../../../../../api/Api";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";
import DownloadJpegButton from "../../../../../../../../components/downloadJpegButton/DownloadJpegButton";

const Tab4ContentChartIncomer = () => {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext);

    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);

    const chartRef = useRef();

    const getCredentials = () => ({
        USER_ID: localStorage.getItem("LoginID"),
        PLANT_code: localStorage.getItem("LCODE"),
        pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        Stype: "I",
    });

    const fetchLogData = async () => {
        setLoading(true);

        try {
            const credentials = getCredentials();
            const res = await MainSliderApi(credentials);

            if (res?.data && Array.isArray(res.data)) {
                const transformedData = res.data.map((item) => ({
                    name: item.NAME || "",
                    Peak_KW: parseFloat(item.KW_MAX) || 0,
                    KW: parseFloat(item.KW) || 0,
                    DAY_KWH: parseFloat(item.DAY_KWH) || 0,
                }));

                setChartData(transformedData);
            } else {
                setChartData([]);
            }
        } catch (error) {
            console.error("Error fetching chart data:", error);
            setChartData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, []);

    return (
        <div className="row">
            <div
                className="col-md-12"
                style={{
                    height: 240,
                    position: "relative",
                }}
            >
                {/* Action Buttons */}
                <div
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: 10,
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                    }}
                >
                    <DownloadJpegButton
                        targetRef={chartRef}
                        fileName="Peak_KW_vs_KW.jpeg"
                    />

                    <IconButton onClick={fetchLogData} disabled={loading}>
                        <Refresh />
                    </IconButton>

                    {loading && <CircularProgress size={24} />}
                </div>

                {/* Chart */}
                <div
                    ref={chartRef}
                    style={{
                        height: 190,
                        background: "#fff",
                        padding: "10px",
                        marginTop: "50px",
                    }}
                >
                    {loading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                            }}
                        >
                            <CircularProgress />
                        </div>
                    ) : (
                        <ResponsiveContainer width="100%" height="100%">
                            <ComposedChart
                                data={chartData}
                                margin={{
                                    top: 20,
                                    right: 40,
                                    left: 20,
                                    bottom: 20,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                    dataKey="name"
                                    angle={-20}
                                    textAnchor="end"
                                    height={70}
                                    interval={0}
                                    tick={{ fontSize: 11 }}
                                    tickFormatter={(value) =>
                                        value && value.length > 5
                                            ? `${value.substring(0, 5)}...`
                                            : value
                                    }
                                />

                                {/* Left Axis */}
                                <YAxis
                                    yAxisId="left"
                                    orientation="left"
                                    width={70}
                                    tick={{ fontSize: 12 }}
                                    label={{
                                        value: "Peak KW / Current KW",
                                        angle: -90,
                                        position: "insideLeft",
                                        style: {
                                            textAnchor: "middle",
                                        },
                                    }}
                                />

                                {/* Right Axis */}
                                <YAxis
                                    yAxisId="right"
                                    orientation="right"
                                    width={70}
                                    tick={{ fontSize: 12 }}
                                    label={{
                                        value: "Daily kWh",
                                        angle: 90,
                                        position: "insideRight",
                                        style: {
                                            textAnchor: "middle",
                                        },
                                    }}
                                />

                                <Tooltip
                                    cursor={{
                                        fill: "rgba(0,0,0,0.05)",
                                    }}
                                    contentStyle={{
                                        backgroundColor: "#fff",
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                    }}
                                    formatter={(value, name) => [
                                        Number(value).toLocaleString(),
                                        name,
                                    ]}
                                    labelFormatter={(label) =>
                                        `Name : ${label}`
                                    }
                                />

                                <Legend
                                    verticalAlign="top"
                                    align="center"
                                    wrapperStyle={{
                                        paddingBottom: "10px",
                                    }}
                                />

                                {/* Peak KW */}
                                <Bar
                                    yAxisId="left"
                                    dataKey="Peak_KW"
                                    name="Peak KW"
                                    fill="#FFA500"
                                    barSize={22}
                                />

                                {/* Current KW */}
                                <Bar
                                    yAxisId="left"
                                    dataKey="KW"
                                    name="Current KW"
                                    fill="#FFDE21"
                                    barSize={22}
                                />

                                {/* Daily kWh */}
                                <Line
                                    yAxisId="right"
                                    type="monotone"
                                    dataKey="DAY_KWH"
                                    name="Daily kWh"
                                    stroke="#008080"
                                    strokeWidth={3}
                                    dot={{ r: 4 }}
                                    activeDot={{ r: 7 }}
                                />
                            </ComposedChart>
                        </ResponsiveContainer>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Tab4ContentChartIncomer;